/* unplugin-vue-components disabled */import script from "./BaseDialog.vue?vue&type=script&setup=true&name=BaseDialog&lang=js"
export * from "./BaseDialog.vue?vue&type=script&setup=true&name=BaseDialog&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=3b7c1dd5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7c1dd5"]])

export default __exports__